import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { AddressRepository } from '../../../../store/address-state/address-state.repository';
import { Address } from '@/types';

interface getAddressDataTableStructureProps {
  store: AddressRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getAddressDataTableStructure = ({ store, createAction, rowActions }: getAddressDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.address.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const addressColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.address.table.address',
    accessorKey: 'address',
    variant: DataTableColumnVariant.TEXT,
  };
  const typeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.address.table.type',
    accessorKey: 'type.description',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'settings.address.table.singular',
    plural: 'settings.address.table.plural',
    columns: [idColumn, typeColumn, addressColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: Address) => {
      store.set('response', row);
      // store.set('dto', {
      //   address: row.address,
      //   typeId: row.type.id,
      // });
      // store.set('addressTypeSelected', { name: row.type.description, code: row.type.id });
    },
    createAction,
    rowActions,
    searchableFields: ['id', 'address', 'type.description'],
  };
};
